import { useState } from "react";
import { useToast } from "../../../components/ui/use-toast";
import { IPatient } from "../../../types";
import { axiosInstance } from "../../../services/axiosInstance"; 
export const useUpdatePatient = () => {
  const { toast } = useToast();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdatePatient = async (
    patient: IPatient,
    height: string,
    weight: string
  ) => {
    setIsUpdating(true);
    try {
      const response = await axiosInstance.post(
        "/doctor-profile/patient-profile/add-patient",
        {
          ...patient,
          height,
          weight,
        }
      );

      toast({
        title: "Patient details updated",
        description: "Height and weight updated successfully.",
      });

    } catch (error) {
      console.error("Error updating patient details:", error);
      toast({
        title: "Error",
        description: "An error occurred while updating patient details.",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  return { handleUpdatePatient, isUpdating };
};
